import { Directive, ElementRef, Input } from '@angular/core';

import type { RtComponentSize } from '../../props/component-size';
import type {
  RtAddNewButtonVariant,
  RtButtonColorContextVariant,
  RtButtonVariant,
  RtIconButtonVariant,
  RtInfoboxButtonVariant,
  RtPlanButtonVariant,
  RtWalkthroughButtonVariant,
} from './button.types';

@Directive({
  standalone: true,
  selector: 'rt-button-base',
  host: {
    '[class]': '"rt-button " + size + " " + variant',
    '[class.disabled]': 'disabled === true',
    '[class.active]': 'active === true',
    '[class.pressed]': 'pressed === true',
    '(click)': 'onClick($event)',
  },
})
export abstract class BaseButtonDirective {
  @Input() public size: Extract<RtComponentSize, 'small' | 'medium' | 'small-x'> = 'medium';
  @Input() public variant:
    | RtButtonVariant
    | RtPlanButtonVariant
    | RtIconButtonVariant
    | RtAddNewButtonVariant
    | RtInfoboxButtonVariant
    | RtWalkthroughButtonVariant
    | RtButtonColorContextVariant;
  @Input() public disabled: boolean = false;
  @Input() public active: boolean = false;
  @Input() public pressed: boolean = false;

  constructor(public elRef: ElementRef) {}

  public onClick(event: Event) {
    if (!this.disabled) return;

    event.preventDefault();
    event.stopImmediatePropagation();
  }
}
